import React from 'react';
import Seal from '../assets/print/seal_corporate.png';
import Seal2 from '../assets/print/seal_general.png';
import Logo from '../assets/print/logo_corporate.png';
import Logo2 from '../assets/print/logo_general.png';
import moment from 'moment';
import { Get as GetConfig } from '../view/basic/http';
import lodash from 'lodash';

const day = ['일', '월', '화', '수', '목', '금', '토'];

class Bill extends React.Component {
    render() {
        const { datas } = this.props;
        let objs = {};
        datas.map(x => {
            if (!objs[x.inspct_kind_nm]) {
                objs[x.inspct_kind_nm] = [];
            }
            objs[x.inspct_kind_nm].push(x);
            return x;
        });

        const tables = [];

        let totalNum = 0;
        let totalBranchPrice = 0;
        for (var key in objs) {
            const data = objs[key];

            const recptn_cnt = lodash.sum(data.map(x => x.recptn_cnt));
            const branchPrice = lodash.sum(data.map(x => x.branchPrice * x.recptn_cnt));
            totalBranchPrice += branchPrice;
            totalNum += recptn_cnt;

            tables.push(
                <tr>
                    <td>{key}</td>
                    <td>{recptn_cnt}</td>
                    <td>{branchPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                    <td>
                        {Math.floor(branchPrice * 0.1)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    </td>
                    <td>
                        {Math.floor(branchPrice * 1.1)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    </td>
                </tr>,
            );
        }

        for (var i = tables.length; i < 10; i++) {
            tables.push(
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>,
            );
        }

        return (
            <div className="print_content">
                <div className="content">
                    <div className="table_list">
                        <table className="tbl_board_report">
                            <colgroup>
                                <col width="150" />
                                <col width="100" />
                                <col width="100" />
                                <col width="100" />
                                <col width="100" />
                                <col width="100" />
                                <col width="100" />
                            </colgroup>
                            <tr>
                                {/* <td colSpan={4} className="content_left" style={{ fontSize: 22, borderBottomColor: '#00000000' }}>
                                    No.01
                                </td> */}
                                <td colSpan={4} rowSpan={2} style={{ fontSize: 26, fontWeight: 'bold' }}>
                                    <font style={{ color: 'blue', fontSize: 22 }}> (한국분동주식회사)</font>
                                    <br />
                                    용역비 지출결의서
                                </td>
                                <td>실장</td>
                                <td>제무회계감사</td>
                                <td>대표</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>용역비청구자</td>
                                <td colSpan={3}>{datas[0].driver.name}</td>
                                <td>전화번호</td>
                                <td colSpan={2}>{datas[0].driver.phone}</td>
                            </tr>
                            <tr>
                                <td>청 구 명</td>
                                <td colSpan={6} className="content_left">
                                    <font style={{ color: 'blue', fontSize: 18 }}>&nbsp;{moment().format('MM월')} 분동운반내역 청구</font>
                                </td>
                            </tr>
                            <tr style={{ borderBottom: 0 }}>
                                <td style={{ borderBottom: 0 }}>용역비책정단가</td>
                                <td style={{ borderBottom: 0 }} colSpan={6}></td>
                            </tr>
                        </table>

                        <table className="tbl_board_report">
                            <colgroup>
                                <col width="170" />
                                <col width="100" />
                                <col width="130" />
                                <col width="130" />
                                <col width="130" />
                            </colgroup>
                            <tr style={{ backgroundColor: 'yellow' }}>
                                <td>검사종류</td>
                                <td>대 수 (개)</td>
                                <td>금액</td>
                                <td>부가세</td>
                                <td>합계</td>
                            </tr>
                            {/* <tr>
                                <td>{data.inspct_kind_nm}</td>
                                <td>{data.recptn_cnt}</td>
                                <td>{data.branchPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                                <td>
                                    {Math.floor(data.branchPrice * 0.1)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </td>
                                <td>
                                    {Math.floor(data.branchPrice * 1.1)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </td>
                            </tr> */}
                            {tables}
                            {/* <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr> */}

                            <tr>
                                <td style={{ fontWeight: 'bold' }}>합계</td>
                                <td>{totalNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                                <td>{totalBranchPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                                <td>
                                    {Math.floor(totalBranchPrice * 0.1)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </td>
                                <td>
                                    {Math.floor(totalBranchPrice * 1.1)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </td>
                            </tr>
                        </table>

                        <table className="tbl_board_report">
                            <colgroup>
                                <col width="150" />
                                <col width="100" />
                                <col width="100" />
                                <col width="100" />
                                <col width="100" />
                                <col width="100" />
                                <col width="100" />
                            </colgroup>
                            <tr style={{ borderTop: 0 }}>
                                <td style={{ borderTop: 0 }}>결재계좌번호</td>
                                <td style={{ borderTop: 0 }} colSpan={6} className="content_left">
                                    {datas[0].driver.account}
                                </td>
                            </tr>
                            <tr>
                                <td>첨부서류</td>
                                <td colSpan={6} className="content_left">
                                    <br />
                                    1.세금계산서
                                    <br />
                                    2.용역실시내역서 - 용역비청구자
                                    <br />
                                    3.용역실시내역서 - 한국분동
                                    <br />
                                    <br />
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={7}>
                                    <br />
                                    <br />
                                    위 금액을 청구 하오니 결재 바랍니다.
                                    <br />
                                    <br />
                                    작성일 : {moment().format('YYYY. MM. DD.')}
                                    <br />
                                    <br />
                                    <font style={{ fontSize: 16, fontWeight: 'bold' }}>
                                        작성자 : 재무회계감사&nbsp;&nbsp;&nbsp; 유&nbsp;&nbsp; 병&nbsp;&nbsp; 열&nbsp;&nbsp; (인)
                                    </font>
                                    <br />
                                    <br />
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export default Bill;
